import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import * as PaymentsActions from '../../actions';
import * as PaymentsConstants from '../../constants';
import * as D from '../../deps';
import * as PaymentsSelectors from '../../selectors';
import * as PaymentsUtils from '../../utils';
import TOSAgreement from '../TOSAgreement/TOSAgreement';

import * as OwnConstants from './constants';

import './SwitchPlanConfirmationModal.scss';

export const SwitchPlanConfirmationModal = class extends React.Component {
  static propTypes = {
    intl: PropTypes.object,
    isCanceledSubscriber: PropTypes.bool,
    tierSelected: PropTypes.string,
    discountTypeSelected: PropTypes.string,
    durationTypeSelected: PropTypes.string,
    currentProductDurationType: PropTypes.string,
    price: PropTypes.string,
    currency: PropTypes.string,
    vendorSku: PropTypes.string,
    backingProductID: PropTypes.string,
    paymentProvider: PropTypes.string,
    isUpdatingBillingInfo: PropTypes.bool,
    resubscribe: PropTypes.func,
    switchPlan: PropTypes.func,
    closeModal: PropTypes.func,
    stopSwitchingPlans: PropTypes.func,
  };

  onDismissClick = () => {
    this.props.closeModal();
  };

  onSubmitClick = () => {
    if (this.props.isCanceledSubscriber) {
      this.props.resubscribe();
    } else {
      const switchPlanParams = {
        vendorSku: this.props.vendorSku,
        backingProductIdentifier: this.props.backingProductID,
        paymentProvider: this.props.paymentProvider,
        tier: this.props.tierSelected,
        discountType: this.props.discountTypeSelected,
        durationType: this.props.durationTypeSelected,
      };

      this.props.switchPlan(switchPlanParams);
    }

    this.props.closeModal();
    this.props.stopSwitchingPlans();
  };

  renderTitle = () => {
    return (
      <div className='SwitchPlanConfirmationModal__title'>
        <FormattedMessage {...OwnConstants.messages.reviewYourChange} />
      </div>
    );
  };

  renderSubtitle = () => {
    return (
      <div className='SwitchPlanConfirmationModal__subtitle'>
        <FormattedMessage {...OwnConstants.messages.youAreChangingTo} />
      </div>
    );
  };

  renderOffer = () => {
    const { tierSelected, discountTypeSelected, durationTypeSelected, intl, price, currency } =
      this.props;

    const frequency = PaymentsUtils.getPaymentFrequencyForDurationType(durationTypeSelected);

    return (
      <div className='SwitchPlanConfirmationModal__offer'>
        <div className='SwitchPlanConfirmationModal__offer__planName'>
          {PaymentsUtils.getPlanName(tierSelected, discountTypeSelected)}
        </div>
        <div className='SwitchPlanConfirmationModal__offer__price'>
          <FormattedMessage
            {...OwnConstants.messages.offerPrice}
            values={{
              price: PaymentsUtils.formatPrice(intl, price, currency),
              frequency,
            }}
          />
        </div>
      </div>
    );
  };

  renderPlanBlurb = () => {
    const { tierSelected, discountTypeSelected } = this.props;

    const planBlurb = PaymentsUtils.getPlanBlurb(tierSelected, discountTypeSelected);

    return (
      <div className='SwitchPlanConfirmationModal__planBlurb'>
        <FormattedMessage {...planBlurb} />
      </div>
    );
  };

  renderTOS = () => {
    return (
      <div className='SwitchPlanConfirmationModal__TOS'>
        <TOSAgreement
          tier={this.props.tierSelected}
          discountType={this.props.discountTypeSelected}
          durationType={this.props.durationTypeSelected}
        />
      </div>
    );
  };

  renderButtons = () => {
    return (
      <div className='SwitchPlanConfirmationModal__buttonRow'>
        <D.ButtonT3
          className='SwitchPlanConfirmationModal__dismissButton'
          onClick={this.onDismissClick}
          isInline={true}
          theme={D.ButtonT3Theme.LIGHT_TRANSPARENT}
          size={D.ButtonT3Size.LARGE}
        >
          <FormattedMessage {...PaymentsConstants.Messages.dismiss} />
        </D.ButtonT3>
        <D.ButtonT3
          className='SwitchPlanConfirmationModal__ctaButton'
          onClick={this.onSubmitClick}
          isInline={true}
          type={D.ButtonT3Type.SUBMIT}
          size={D.ButtonT3Size.LARGE}
        >
          <FormattedMessage {...PaymentsConstants.Messages.submit} />
        </D.ButtonT3>
      </div>
    );
  };

  render() {
    return (
      <div className='SwitchPlanConfirmationModal'>
        <div className='SwitchPlanConfirmationModal__header'>
          {this.renderTitle()}
          {this.renderSubtitle()}
        </div>
        <div className='SwitchPlanConfirmationModal__body'>
          {this.renderOffer()}
          {this.renderPlanBlurb()}
        </div>
        <div className='SwitchPlanConfirmationModal__footer'>
          {this.renderTOS()}
          {this.renderButtons()}
        </div>
      </div>
    );
  }
};

export function mapStateToProps(state, ownProps) {
  const { tierSelected, discountTypeSelected, durationTypeSelected } = ownProps;

  const isCanceledSubscriber = PaymentsSelectors.isCurrentListenerCanceledSubscriber(state);
  const currency = PaymentsSelectors.getActiveProductCurrency(state);
  const getBackingProductPrice = PaymentsSelectors.createGetBackingProductPriceSelector(state);
  const price = getBackingProductPrice(tierSelected, discountTypeSelected, durationTypeSelected);
  const paymentProvider = PaymentsSelectors.getSubscriptionPaymentProvider(state);
  const getOfferVendorSku = PaymentsSelectors.createGetOfferVendorSkuSelector(state);
  const vendorSku = getOfferVendorSku(tierSelected, discountTypeSelected, paymentProvider);
  const getOfferBackingProductId = PaymentsSelectors.createGetOfferBackingProductIdSelector(state);
  const backingProductID = getOfferBackingProductId(
    tierSelected,
    discountTypeSelected,
    durationTypeSelected,
  );

  return {
    isCanceledSubscriber,
    tierSelected,
    discountTypeSelected,
    durationTypeSelected,
    currency,
    price,
    vendorSku,
    backingProductID,
    paymentProvider,
  };
}

export default injectIntl(
  connect(mapStateToProps, {
    closeModal: D.Actions.Modal.closeModal,
    stopSwitchingPlans: PaymentsActions.stopSwitchingPlans,
    resubscribe: PaymentsActions.resubscribe,
    switchPlan: PaymentsActions.switchPlan,
  })(SwitchPlanConfirmationModal),
);
